export const chatDispatcher = {
  enqueueCanvasUserAction(payload: unknown) {
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('a2ui:canvas-user-action', { detail: payload }));
  },
};
